/**
 * /terms — public Terms of Service page.
 *
 * Same approach as /privacy — see src/routes/privacy.tsx and
 * src/components/legal/LegalDocumentShell.tsx for the rationale behind
 * serving the vendored HTML via <iframe> instead of a plain React page.
 */

import { createFileRoute } from '@tanstack/react-router';
import { LegalDocumentShell } from '@/components/legal/LegalDocumentShell';

export const Route = createFileRoute('/terms')({
  component: TermsPage,
});

function TermsPage() {
  return <LegalDocumentShell src="/terms.html" title="Terms of Service" />;
}
